// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__17a02","Logo":"Navbar_Logo__dHxcQ","DesktopOnly":"Navbar_DesktopOnly__3YyPg"};